export enum BooleanEnum {
  True = 'true',
  False = 'false',
}
